<div class="flex-page">
  @if (showHeaderFooter) {
    <div class="flex-header">
      <app-header [theme]="theme" [simple]="simple" (themeChange)="themeChange($event)"></app-header>
    </div>
  }
  <div toastContainer></div>

  <div class="flex-main fit-x">
    @if (navigating()) {
      <cz-spinner class="loader-section" />
    }
    <router-outlet (activate)="onActivate()"></router-outlet>
  </div>

  @if (showHeaderFooter) {
    <div class="flex-footer">
      <app-footer></app-footer>
    </div>
  }
</div>
